export default __webpack_public_path__ + "static/media/logo.941c671d.png";